var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page',{attrs:{"title":"invoices.outcome.label","bread-crumb-data":_vm.breadCrumbData}},[_c('invoices-table',{attrs:{"type":'OUTCOME',"page-data-id":"invoicesOutcome"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }